import React from 'react';
import Skeleton from 'components/commercetools-ui/atoms/skeleton';
import Preview from 'components/commercetools-ui/organisms/checkout/components/steps/previews/wrapper';
import { useFormat } from 'helpers/hooks/useFormat';

const AmazonpayReviewShippingSkeleton = () => {
  const { formatMessage: formatCheckoutMessage } = useFormat({ name: 'checkout' });
  return (
    <div>
      <div className="flex items-center justify-between rounded-t-sm border border-neutral-400 bg-white p-12 transition lg:rounded-t-md lg:bg-white lg:px-36 lg:py-24">
        <div className="flex cursor-default items-center gap-12 lg:gap-16">
          <h5 className="text-primary-black transition lg:text-18 lg:text-primary-black">
            {formatCheckoutMessage({ id: 'shipping', defaultMessage: 'Shipping' })}
          </h5>
        </div>
        <span>
          <div className="relative mb-10 h-15 w-[30px]">
            <Skeleton></Skeleton>
          </div>
        </span>
      </div>

      <Preview>
        <div className="border border-neutral-400 p-16">
          <div className="flex items-center justify-between py-18 pl-18">
            <div>
              <div className="relative mb-10 h-15 w-[120px]">
                <Skeleton></Skeleton>
              </div>
              <div className="relative  h-15 w-[185px] lg:w-[330px]">
                <Skeleton></Skeleton>
              </div>
            </div>

            <span className="text-14 font-medium">
              <div className="relative mb-10 h-15 w-[30px]">
                <Skeleton></Skeleton>
              </div>
            </span>
          </div>
        </div>
      </Preview>
    </div>
  );
};

export default AmazonpayReviewShippingSkeleton;
